export default __webpack_public_path__ + "static/media/magnifyBee.3804459c.png";